import './geom-objects/all-objects'
import './geom-relations/all-relations'

// to parse xxxxx.cg3 files

class Parser {

    constructor (url, options) {
        this.url = url;
        this.options = options;
    }

    fetchIt () {
        return new Promise((resolve, reject) => {
            if (this.options && this.options.source === "content-in-url") {
                try {
                    let xmlStr = this.url;
                    //console.log("Parsing from ", xmlStr);
                    let tree = new window.DOMParser().parseFromString(xmlStr,
                        "text/xml");
                    resolve(tree);
                } catch (e) {
                    reject(e);
                }
            }
            else { // URL is to be fetched
                // strongly inspired from
                // http://ccoenraets.github.io/es6-tutorial-data/promisify/
                let xhr = new XMLHttpRequest();
                xhr.overrideMimeType("application/xml");
                xhr.open("GET", this.url);
                let obj = this.options || {};
                if (obj.headers) {
                    Object.keys(obj.headers).forEach(key => {
                        xhr.setRequestHeader(key, obj.headers[key]);
                    });
                }
                xhr.onload = () => {
                    if (xhr.status >= 200 && xhr.status < 300)
                        resolve(xhr.responseXML);
                    else
                        reject(xhr.statusText);
                };
                xhr.onerror = () => reject(xhr.statusText);
                xhr.send(obj.body);

            }
        });
    }

    /** Crawls in javascript through the objects
     * expected to define key-value-pairs stored in the preferences. */
    async parseJS () {
        let responseXML = await this.fetchIt();
        window.responseXML = responseXML;
        let root = responseXML.children[0],
            count = root.childElementCount;
        this.objects = {};
        for (let i = 0; i < count; i++)
            this.processElement(root.children[i]);
        return this.objects;
    }

    /** Creates TreeRep C-objects which are then read-back.
     * Use this for parsing geometry files. */
    async parse () {
        cabri.parser = this;
        let responseXML = await this.fetchIt();
        window.responseXML = responseXML;
        let root = responseXML.children[0];
        this.objects = {};
        this.objectLayers = {};
        // parse internally in C++
        let e = root.firstElementChild;
        for (let c = 0; c < root.childElementCount; c++) {
            if (c > 0) e = e.nextElementSibling;
            if (e.localName == "expression") continue;
            if (e.localName == "gview3") {
                //console.log("Creating view");
                const peer = new GView(e);
                this.objects["view"] = peer;
                //continue;
            }
            this.feedElement(e);
        }
        // then create peers
        console.log(
            "========== parsing element list to DE-objects ==============");
        cabri.emsc.parseEltList();
        console.log(
            "========== traversing DE-objects to create peers ==============");
        // call parseStep on each object
        cabri.emsc.traverseApplicationObjects();
        console.log("========== traversing concluded ==============");
        // shake a bit to get them defined
        try {
            let numObj = cabri.emsc.operateAll();
            console.log("OperateAll on " + numObj + " objects.");
        } catch (e) {
            console.warn("OperateAll failed.");
        }

        //delete cabri.parser;
        return this.objects;
    }

    feedElement (elt) {
        console.log("-------------- " + elt.tagName);
        let parent = window.cabri.emsc.makeTreeRep1(elt.tagName, true);
        let i = 0, previous = 0, count = elt.childElementCount;
        let e = elt.firstElementChild;
        let id = null;
        for (let c = 0; c < count; c++) {
            if (c > 0) e = e.nextElementSibling;
            //console.log("Feeding " + e.tagName);
            previous = i;
            if(e.childNodes.length===0) continue;
            let text = e.childNodes[0].nodeValue;
            if ("graphic_layers" === e.tagName) this.objectLayers[id] = text;
            if ("id" === e.tagName) id = text;
            if (text)
                i = window.cabri.emsc.makeTreeRep2(e.tagName, text, false);
            else
                i = window.cabri.emsc.makeTreeRep1(e.tagName, false);
            if (c === 0)
                window.cabri.emsc.setTreeRepChild(parent, i);
            else
                window.cabri.emsc.setTreeRepNext(previous, i);
            parent = i;
        }
    }

    /** Called by the traversal C code. */
    parse_step (objectId, className) {
        // sanitize name... sadly necessary
        className = className.replace(/^([a-zA-Z_]*[0-9]*).*$/, "$1");
        //console.log(`Processing object "${className}" ${objectId}.`);
        let peer = null;
        switch (className) {
            case "line3":
                peer = new Line(objectId);
                break;
            case "point3":
                peer = new Point(objectId);
                break;
            case "subline3":
                peer = new Subline(objectId);
                break;
            case "plane3":
                peer = new Plane(objectId);
                break;
            case "conic3":
                peer = new Conic(objectId);
                break;
            case "vector3":
                peer = new Vector(objectId);
                break;
            case "subplane3":
                peer = new Subplane(objectId, className);
            case "polynet3":
                peer = new RenderableMesh(objectId, className);
                break;
            case "quadric3":
                peer = new Quadric(objectId, className);
                break;
            case "gview3": // currently fails as gview3.cpp is not properly compiled in
                peer = new GView(objectId);
                break;
            /* are relations useful??
             case "free_point_on_plane3":
             peer = new FreePointOnPlaneRel(objectId); break;
             case "free_point_on_line3":
             peer = new FreePointOnLineRel(objectId); break;
             case "segment_by_two_points3":
             peer = new SegmentByTwoPoints(objectId);
             break;
             case "vector_by_two_points3":
             peer = new VectorByTwoPoints(objectId);
             break;
             */
            default:
                const re = new RegExp(/.*_(on|in|by|)_.*/);
                if(!re.test(className) ) // relations are probably not needed
                    console.log(
                        `Ignoring element "${className}" (not yet implemented).`);
        }
        if (!peer)
            return;

        if (typeof (peer.setLayers) == "function") peer.setLayers(
            this.objectLayers[peer.getId()]);

        this.objects [peer.getId()] = peer;
    }
}

class ConfigParser extends Parser {
    constructor (url, options) {
        super(url, options);
        this.configObject = {};
    }

    processElement (elt) {
        if (elt.tagName === "color") {
            this.configObject[this.getChildText(elt, "id")] =
                this.getChildText(elt, "value");
            // THINKME: actually, we could use a Babylon Material?
        }
        else
            if (elt.tagName === "real") {
                this.configObject[this.getChildText(elt, "id")] =
                    Number.parseFloat(this.getChildText(elt, "value"));
            }
            else
                if (elt.tagName === "int") {
                    this.configObject[this.getChildText(elt, "id")] =
                        Number.parseInt(this.getChildText(elt, "value"));
                }
    }

    getChildText (elt, name) {
        let count = elt.childElementCount;
        let value = null;
        for (let i = 0; i < count; i++) {
            let c = elt.children[i];
            if (name === c.nodeName) {
                value = c.textContent;
            }
        }
        return value;
    }

    async parse () {
        await super.parseJS();
        return this.configObject;
    }

}

export {Parser, ConfigParser};